const developerRoleExists = (Roles) => {
  let dev = Array.isArray(Roles)
    ? Roles.filter((role) => {
        return role.roleName === "developer";
      })
    : [];
  return dev.length > 0;
};

export default developerRoleExists;
